import { FC, useContext } from 'react';

import { Button, H2, Modal } from '@smartshell/ui-kit';

import { ESettingsAliases, SettingsContext } from 'settings';

import s from './DisablingCashBox.module.scss';
import { IDisablingCashBoxProps } from './interfaces';

export const DisablingCashBox: FC<IDisablingCashBoxProps> = ({ onClose }) => {
  const {
    actions: { setSetting },
  } = useContext(SettingsContext);
  return (
    <Modal className={s.modal} onClose={onClose}>
      <div className={s.header}>
        <H2>Отключение кассы</H2>
        <span className={s.subtitle}>
          Оплата через эту кассу станет недоступна, и оператор не сможет
          использовать её для приема платежей до повторного включения. Вы
          уверены, что хотите отключить кассу?
        </span>
      </div>
      <div className={s.buttons_block}>
        <Button
          variant="outline"
          color="red"
          onClick={() => {
            setSetting({
              alias: ESettingsAliases.CASHBOX,
              value: '0',
            });
            onClose();
          }}
          className={s.button}
          fullWidth
        >
          Отключить
        </Button>
        <Button onClick={() => onClose()} className={s.button} fullWidth>
          Отменить
        </Button>
      </div>
    </Modal>
  );
};
